export enum AdminAuthRoles {
  ADMIN = 'admin',
  ACCOUNTANT = 'accountant',
  CUSTOMER_CARE = 'customer-care',
  DEBT_COLLECTOR = 'debt-collector',
  DEV = 'dev',
}
